import { render, staticRenderFns } from "./Sorveglianza.vue?vue&type=template&id=9ecdcf24&"
import script from "./Sorveglianza.vue?vue&type=script&lang=ts&"
export * from "./Sorveglianza.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports